<template>
    <div>
        <!--   回复 -->
        <div style="width: 1500px;height:auto;overflow:hidden;background: #FFFFFF;box-shadow: rgba(0 0 0 0.7);">
        <div class="input_dh" style="margin: 0 auto;margin-top: 10px;">
<!--            <Editor :tinymce_height="'780'"  :innerDrawer = "innerDrawer = true" :value="sendContent"  ref="ch"></Editor>-->
            <el-input style="width: calc(100% - 20px);margin-left: 10px;" type="textarea" resize="none" :rows="5" placeholder="发布你的回答" v-model="sendContent" :autosize="{ minRows: 5, maxRows: 10 }" :show-word-limit="true" maxlength="6000" minlength="10" @input="content_input" />
        </div>
        <div  style="float: right;margin-top: 18px;margin-right: 10px;">
            <el-button type="primary" @click="checkAnswer" style="margin-left: 15px;" size="medium" round class="hand op sc">回答</el-button>
        </div>
        <!--    上传图片     -->
        <div class="input_box_btn op sc hand" @click="set_upload_img_open" style="position: relative;margin-left: 10px;">
            <div class="input_box_btn_icon" style="margin-top: 2px;">
                <svg t="1700457632553" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11668" width="25" height="25"><path d="M632 992H172.8c-70.4 0-128-57.6-128-128V352c0-176 144-320 320-320h267.2c70.4 0 128 57.6 128 128v704c0 70.4-57.6 128-128 128z" fill="#E1E1DF" p-id="11669"></path><path d="M852.8 992H326.4c-70.4 0-128-57.6-128-128V336c0-70.4 57.6-128 128-128h526.4c70.4 0 128 57.6 128 128v528c0 70.4-57.6 128-128 128z" fill="#4E8DF6" p-id="11670"></path><path d="M320 417.6a110.4 110.4 0 1 0 220.8 0 110.4 110.4 0 1 0-220.8 0Z" fill="#FFFFFF" p-id="11671"></path><path d="M875.2 606.4c-48-48-126.4-48-174.4 0L321.6 985.6l-6.4 6.4h536c70.4 0 128-57.6 128-128v-152l-104-105.6z" fill="#2166CC" p-id="11672"></path><path d="M731.2 992l-272-273.6c-48-48-126.4-48-174.4 0l-84.8 86.4V864c0 70.4 57.6 128 128 128h403.2z" fill="#629FF9" p-id="11673"></path></svg>
            </div>
            <div class="input_box_btn_name" >上传照片</div>
            <el-badge :value="imgs.length" style="position:absolute; z-index:10; left:0px;top: 14px" v-if="imgs.length > 0"></el-badge >
        </div>
        <!--  上传视频   -->
        <div class="input_box_btn op sc hand" @click="set_visibleVideos"  style="position: relative; margin-right: 8px">
            <div class="input_box_btn_icon" style="margin-top: 4px;margin-left: 10px"><svg t="1700457844773" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14809" width="25" height="25"><path d="M661.942857 73.142857H146.285714c-20.114286 0-36.571429 16.457143-36.571428 36.571429v804.571428c0 20.114286 16.457143 36.571429 36.571428 36.571429h731.428572c20.114286 0 36.571429-16.457143 36.571428-36.571429V325.485714L661.942857 73.142857z" fill="#8095FF" p-id="14810"></path><path d="M661.942857 288.914286c0 20.114286 16.457143 36.571429 36.571429 36.571428H914.285714L661.942857 73.142857v215.771429z" fill="#B6C6FF" p-id="14811"></path><path d="M632.685714 437.028571H301.714286c-20.114286 0-36.571429 18.285714-36.571429 42.057143v279.771429c0 23.771429 16.457143 42.057143 36.571429 42.057143h332.8c20.114286 0 36.571429-18.285714 36.571428-42.057143V479.085714c-1.828571-21.942857-18.285714-42.057143-38.4-42.057143z" fill="#FFFFFF" p-id="14812"></path><path d="M782.628571 513.828571c-9.142857-7.314286-20.114286-10.971429-31.085714-9.142857l-89.6 20.114286c-16.457143 3.657143-29.257143 21.942857-29.257143 42.057143v106.057143c0 20.114286 12.8 38.4 29.257143 42.057143l89.6 20.114285h7.314286c9.142857 0 16.457143-3.657143 23.771428-9.142857 9.142857-7.314286 12.8-20.114286 12.8-32.914286v-146.285714c0-12.8-3.657143-23.771429-12.8-32.914286z" fill="#FFFFFF" opacity=".8" p-id="14813"></path><path d="M488.228571 524.8h104.228572V566.857143h-104.228572z" fill="#8095FF" p-id="14814"></path></svg></div>
            <div class="input_box_btn_name" >上传视频</div>
            <el-badge :value="videos.length" style="position:absolute; z-index:10; left:130px;top: 14px" v-if="videos.length > 0"></el-badge >
        </div>
        <!--    上传附件  -->
        <div class="input_box_btn op sc hand" @click="set_visibleFiles" style="position: relative; margin-right: 8px">
            <div class="input_box_btn_icon" style="margin-top: 4px;margin-left: 10px"><svg t="1700458448013" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="21815" width="25" height="25"><path d="M881.371 362.057v570.514c0 25.6-18.285 43.886-43.885 43.886H186.514c-25.6 0-43.885-18.286-43.885-43.886V91.43c0-25.6 21.942-43.886 43.885-43.886h431.543l263.314 314.514z m-40.228 3.657L618.057 98.743l3.657 230.4c0 25.6 14.629 40.228 29.257 40.228l190.172-3.657z m-256-285.257H186.514c-7.314 0-10.971 3.657-10.971 10.972v844.8c0 7.314 3.657 10.971 10.971 10.971h650.972c7.314 0 10.971-3.657 10.971-10.971V402.286H650.971c-36.571 0-62.171-32.915-62.171-73.143l-3.657-248.686z" fill="#BEC3CC" p-id="21816"></path><path d="M881.371 501.029H142.63c-18.286 0-29.258 7.314-29.258 25.6v314.514c0 14.628 10.972 25.6 29.258 25.6h742.4c18.285 0 29.257-7.314 29.257-25.6V522.97c-3.657-14.628-10.972-21.942-32.915-21.942zM332.8 760.686h-14.629v-7.315c-3.657-7.314-3.657-14.628-3.657-18.285h14.629c10.971 0 14.628-7.315 14.628-18.286 0-14.629-7.314-32.914-18.285-51.2l18.285-69.486h-29.257v204.8h-25.6v-230.4h76.8v25.6l-18.285 65.829c14.628 18.286 18.285 36.571 18.285 58.514 0 25.6-10.971 36.572-32.914 40.229zM409.6 614.4v186.514H384V658.286c0 3.657-3.657 7.314-7.314 10.971s-7.315 10.972-7.315 10.972c0-3.658-3.657-10.972-3.657-18.286 0-3.657-3.657-10.972-3.657-10.972 18.286-29.257 32.914-58.514 40.229-91.428l25.6 3.657c-3.657 10.971-7.315 25.6-18.286 43.886v7.314zM522.971 640H501.03v120.686c0 25.6-10.972 36.571-32.915 36.571h-29.257c0-10.971-3.657-18.286-3.657-25.6h25.6c14.629 0 18.286-3.657 18.286-18.286V636.343h-51.2v-25.6h51.2v-51.2h25.6v51.2h21.943V640z m-106.057 25.6l21.943-7.314c7.314 18.285 18.286 36.571 25.6 51.2l-21.943 10.971c-7.314-18.286-18.285-36.571-25.6-54.857zM588.8 800.914h-25.6v-128c-7.314 10.972-14.629 25.6-25.6 36.572-3.657-14.629-3.657-25.6-7.314-36.572 18.285-29.257 36.571-65.828 47.543-109.714l25.6 7.314c-3.658 18.286-10.972 36.572-18.286 51.2v179.2z m190.171-80.457H716.8v76.8h-25.6v-76.8h-84.114v-25.6H691.2V640h-40.229c-3.657 14.629-10.971 29.257-14.628 40.229-3.657-3.658-10.972-3.658-18.286-7.315-3.657 0-3.657 0-3.657-3.657 10.971-25.6 21.943-54.857 29.257-95.086l25.6 3.658c-3.657 10.971-3.657 21.942-7.314 32.914h32.914v-54.857h25.6v54.857h54.857v25.6h-54.857v58.514h62.172v25.6z" fill="#0090FF" p-id="21817"></path></svg></div>
            <div class="input_box_btn_name" style="">上传文件</div>
            <el-badge :value="files.length" style="position:absolute; z-index:10;left: 230px;top:14px" v-if="files.length > 0"></el-badge >
        </div>
        <div v-if=" imgs.length > 0 || videos.length > 0 || files.length > 0" style="display: flex; margin-bottom: 10px; float: right; overflow:hidden; margin-right: 0px;margin-top: 25px;">
            <div style="width: 70px;font-size: 16px;color: #FF9800;">文件权限</div>
            <el-dropdown @command="change_common_type" style="margin-right: 10px; font-size: 15px; font-weight: 600;cursor: pointer;">
                <div>{{common_type_name[common_type]}}<i  class="el-icon-arrow-down" style="font-weight: 600; margin: 0 10px;margin-top: 5px;"></i></div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="1"><i class="el-icon-view" style="color: #5A6FE6;"></i>公开</el-dropdown-item>
                    <el-dropdown-item command="0"><i class="el-icon-user" style="color: #FF9800;" ></i>不公开</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <!--    传图片  -->
        <el-dialog :close-on-click-modal="false" :show-close=false :visible.sync="visibleImages"  width="400px" >
            <el-tabs v-model="src_tabs_name" :append-to-body="true" type="border-card" >
                <el-tab-pane label="电脑上传" name="pc" >
                    <div>
                        <el-upload accept="image/*"  style="width:330px" class="upload-demo" action="" drag multiple :http-request="upload_img" :limit=80 :show-file-list="false" :on-exceed="fileListNum">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
                        </el-upload>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <div style="overflow: hidden; height:20px;line-height:20px; padding: 0 0px;background: #FFFFFF">
                <div style="float:left;">
                    图片:（{{imgs.length}}）<!-- /9 -->
                </div>
            </div>
            <div style="overflow:hidden; display: flex; flex-wrap: wrap; padding: 10 0px 0px 0px;background: #FFFFFF" class="upload">
                <div style="width: 170px; height: 120px; margin-right: 10px;margin-top:10px;border-radius: 5px;background-size:100% 100%;" class="img" v-for="(item,index) in imgs" :key="index" :style="{backgroundImage:'url('+item.url}">
                    <div style="background:#ff7575;color:#FFF;text-align:center;width:20px;height:20px;line-height:20px;border-radius:10px;float:right; cursor:pointer;user-select: none;" @click="removeImg(index)">
                        <i class="el-icon-close"></i>
                    </div>
                </div>
            </div>
            <div style="display: flex; justify-content: flex-end;background: #FFFFFF">
                <el-button style="width: 80px;border-radius: 5px; margin: 10px 20px" @click="cancelImg">取消</el-button>
                <el-button style="width: 80px;border-radius: 5px; background-color: #031F88; color: #fff; margin: 10px 16px 10px 0" @click="visibleImages = false">确定</el-button>
            </div>
        </el-dialog>
        <!-- 传视频 -->
        <el-dialog :close-on-click-modal="false" :show-close=false :visible.sync="visibleVideos" :append-to-body="true" width="400px">
            <el-tabs v-model="active_name" type="border-card">
                <el-tab-pane label="电脑上传" name="pc" >
                    <el-upload accept="video/*" :on-change="onchange_videos"  style="width:330px"  class="upload-demo" action="" drag  :http-request="upload_video" :show-file-list="false">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将视频拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                </el-tab-pane>
            </el-tabs>
            <div style="overflow: hidden; height:20px;line-height:20px; padding: 0 16px; margin-bottom: 10px">
                <div style="float:left;color:#acacac;">
                    视频:（{{videos.length}}）
                </div>
            </div>
            <div style="overflow:hidden;">
                <div v-for="(item,index) in videos" :key="index" :style="{backgroundImage:'url('+item.img_url}" style="width:80px;height:80px;border-radius:3px; float:left; margin:5px; background-size:100% 100%;position:relative;">
                    <div style="width:100%;height:100%;background-color: rgba(0,0,0,.3);">
                        <img :src="ossUrl + 'img/video_play.png'" style="width:50%;height:50%;margin:25%;" />
                    </div>
                    <div style="background:#ff7575;color:#FFF;text-align:center;width:20px;height:20px;line-height:20px;border-radius:10px; cursor:pointer;user-select: none;position:absolute;right:0;top:0;" @click="removeVideo(index)">
                        <i class="el-icon-close"></i>
                    </div>
                </div>
            </div>
            <div style="display: flex; justify-content: flex-end;">
                <el-button style="width: 80px;border-radius: 5px; margin: 10px 20px" @click="cancelVideo">取消</el-button>
                <el-button style="width: 80px;border-radius: 5px; background-color: #031F88; color: #fff; margin: 10px 16px 10px 0" @click="visibleVideos = false">确定</el-button>
            </div>
        </el-dialog>
        <!--      传文件   -->
        <el-dialog :close-on-click-modal="false" :show-close=false :visible.sync="visibleFiles" :append-to-body="true" width="400px">
            <el-tabs v-model="file_tag_name" type="border-card">
                <el-tab-pane label="电脑上传" name="pc" >
                    <div class="file_style">
                        <div class="dragger-file">
                            <el-upload  accept=".pdf, .doc, .docx, .xls, .xlsx"  style="width:330px" class="upload-demo"  action="" drag multiple :http-request="upload_file" :show-file-list="false" >
                                <i class="el-icon-upload" ></i>
                                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                <div class="format">仅限doc、pdf、ppt等文件格式</div>
                            </el-upload>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <div style="overflow: hidden; height:20px;line-height:20px; padding: 0 16px; margin-bottom: 10px">
                <div style="float:left;color:#acacac;">
                    附件:（{{files.length}}）<!-- /9 -->
                </div>
            </div>
            <div style="overflow:hidden;">
                <div class="video" v-for="(item,index) in files" :key="index" style="width:80px;height:100px;border-radius:3px; float:left; margin:5px; background-size:100%;position:relative;" :title="item.file_name">
                    <div class="background" style="width:100%;height:calc(100% - 20px);background-color: rgba(0,0,0,.3);">
                        <!-- <div style="width:100%">{{item.file_name}}</div> -->
                        <img :src="ossUrl+'img/file.png'" style="width:100%;height:100%;" />
                    </div>
                    <div style="height:20px;width:70px;margin: 0 5px;line-height: 20px;text-align: center;word-break:keep-all;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{item.name}}</div>
                    <div style="background:#ff7575;color:#FFF;text-align:center;width:20px;height:20px;line-height:20px;border-radius:10px; cursor:pointer;user-select: none;position:absolute;right:0;top:0;" @click="removeFile(index)">
                        <i class="el-icon-close"></i>
                    </div>
                </div>
            </div>
            <div style="display: flex; justify-content: flex-end;">
                <el-button style="width: 80px;border-radius: 5px; margin: 10px 20px" @click="cancelFiles">取消</el-button>
                <el-button style="width: 80px;border-radius: 5px; background-color: #031F88; color: #fff; margin: 10px 16px 10px 0" @click="visibleFiles = false">确定</el-button>
            </div>
        </el-dialog>
      </div>

    </div>
</template>
<script>

import utils from "../../../utils/utils";

export default {
    components: {

    },
    comments:{

    },
    computed: {
        user() {
            return this.$store.state.user
        },
        is_login(){
            return this.$store.state.is_login
        }
    },
    props: {
        data: {
            type: Object,
        }
    },

    data() {
        return {
            id:0,
            sendContent: '',
            imgs:[],
            videos:[],
            files:[],
            visibleImages: false,
            visibleVideos: false,
            visibleFiles:false,
            src_tabs_name: "pc",
            active_name: "pc",
            file_tag_name: 'pc',
            playerOptions: {},
            // 文件公开
            common_type:"1",
            common_type_name:{
                "1":"公开",
                "0":"不公开",
            },
        }
    },
    watch:{
        data(){
            this.init();
        }
    },

    mounted() {
        this.id = this.$route.query.id;
    },

    methods: {
        //附件是否公开
        change_common_type(command) {
            this.common_type =  command;
        },

        // 检查一级评论参数
        checkAnswer() {
            var that = this;
          if (!this.utils.toAuth(1)) {
            return false
          }
            if(this.sendContent == ""){
                this.utils.err("请输入回答内容");
                return false;
            }

            console.log( this.data.expiredNot,this.data.isCutoff,this.data.isReward,this.user.isBank)
            //没有过期 没有完结 有悬赏 未绑定快捷卡
            if(this.data.isReward == 1){
                if(this.data.expiredNot == 0 && this.data.isCutoff == 0 && this.user.isBank == 0){
                    this.utils.confirmToesc("您暂未绑定快捷卡回答无法被采纳与打赏，是否前往绑定？",()=>{
                        this.utils.b("/user/index/6");
                    },"立即前往","残忍拒绝",()=>{
                        that.answer();
                    });
                }else{
                    that.answer();
                }
            }else{
                that.answer();
            }
        },

        // 添加一级评论
        answer() {
            var that = this;
            var params = {};
            params.qid = that.id;
            params.fid = 0;
            params.images = JSON.stringify(that.imgs);
            params.videos = JSON.stringify(that.videos);
            params.file = JSON.stringify(that.files);
            params.content = that.sendContent;
            params.type = that.data.rewardType;
            params.fileAuth = that.common_type;

            if (params.content == '') {
                that.utils.err("请输入回答内容");
                return false;
            }

            this.utils.confirm("发布完不可编辑,是否确定发布", () => {
                this.newApi.addQuestionReply(params).then(res => {
                    if (res.isSuccess == 1) {
                        that.sendContent = '';
                        that.imgs = [];
                        that.videos = [];
                        that.files = [];
                        that.common_type = '1';
                        that.utils.sus("回答成功");
                        //发送广播
                        that.$EventBus.$emit('addQuestionReply', res.data);
                    }
                })
            })
        },

        set_upload_img_open() {
            if(this.videos.length > 0 || this.files.length > 0){
                this.utils.err("图片、视频、文件只能上传一种");
                this.visibleVideos = false;
                return false;
            } else {
                this.visibleImages = true;
            }
            this.visibleImages = true;
        },

        set_visibleVideos(){
            if(this.imgs.length > 0 || this.files.length > 0){
                this.utils.err("图片、视频、文件只能上传一种");
                this.visibleVideos = false;
                return false;
            }
            this.visibleVideos = true;
            this.common_type = '1'
        },

        set_visibleFiles(){
            if(this.imgs.length > 0 || this.videos.length > 0){
                this.utils.err("图片、视频、文件只能上传一种");
                return false;
            }
            this.visibleFiles = true;
            this.common_type = '1'
        },

        // 移除图片
        removeImg(index) {
            var that = this;
            that.imgs.splice(index, 1);
        },

        // 上传图片
        upload_img(params) {
            this.img_length++ ;
            if (this.img_length>80) {
                this.$message.error('图片数量达到最大数量！');
                return false;
            }
            var that = this;
            var file = params.file;
            if (file.type.indexOf('image') > -1) {
                that.utils.upload(file,function(url){
	                if (!url){
		                return false;
	                }
                    let params = {};
                    params.name = url.name;
                    params.url = url.url;
                    params.hash = url.hash;
                    that.imgs.push(params);
                })
            }else{
                this.$message.error('只能上传图片！')
                return false
            }
        },

        fileListNum:function (files) {
            if (files.length>this.limit) {
                this.$message.error('图片数量不能超过80张!');
            }
        },
        //获取本地视频封面
        onchange_videos(file){
            this.tempVideosUrl = URL.createObjectURL(file.raw);
        },

        // 上传视频
        upload_video(params) {
            var file = params.file;
            var that = this;
            let pa = {};

            if (file.type.indexOf('video') > -1) {
                that.utils.upload(file,function(url) {
	                if (!url){
		                return false;
	                }
                    pa.name = url.name;
                    pa.img_url = url.url + "?x-oss-process=video/snapshot,t_0,f_jpg";
                    pa.url = url.url;
                    pa.hash = url.hash;
                    that.videos.push(pa);
                })
            }else{
                this.$message.error('只能上传视频！')
                return false
            }
        },
        // 移除视频
        removeVideo(index){
            var that = this;
            that.videos.splice(index,1);
        },

        //附件上传
        upload_file:function(params){
            var that = this;
            var file = params.file;
            that.utils.upload(file,function(url){
	            if (!url){
		            return false;
	            }
                var obj = {
                    name:url.name,
                    url:url.url,
                    hash:url.hash
                };
                that.files.push(obj);
            })
        },

        // 移除附件
        removeFile(index) {
            var that = this;
            that.files.splice(index,1);
        },

        // 取消图片上传
        cancelImg() {
            this.imgs = [];
            // this.$refs.popover.doClose();
            this.visibleImages = false;
        },
        // 取消视频上传
        cancelVideo() {
            this.videos = [];
            // this.$refs.popover2.doClose();
            this.visibleVideos = false;
        },
        // 取消文件上传
        cancelFiles() {
            this.files = [];
            this.visibleFiles = false;
        },
        content_input(e){
            var string = e;
            string = string.replace(/<p>/g, "").replace(/<\/p>/g, "");
            string = string.charAt(string.length - 1);
            if (string == "@") {
                this.at_open = true;
            }
        },
        init(){
            var that = this;
            if(that.data.videos != null && that.data.videos > 0){
                that.playerOptions = {
                    playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
                    autoplay: false, // 如果为true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 是否视频一结束就重新开始。
                    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: 'zh-CN',
                    aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [{
                        type: "video/mp4", // 类型
                        src: that.data.videos[0].url// url地址
                    }],
                    poster: that.data.videos[0].img_url, // 封面地址
                    notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                        timeDivider: true, // 当前时间和持续时间的分隔符
                        durationDisplay: true, // 显示持续时间
                        remainingTimeDisplay: false, // 是否显示剩余时间功能
                        fullscreenToggle: true // 是否显示全屏按钮
                    }
                }
            }
        },
    },
}

</script>

<style scoped>
.input_dh {
    width: 100%;
    height: auto;
    overflow: hidden;
    border-radius: 5px 5px 5px 5px;
    margin-left: 80px;
}
/deep/ .el-input__inner {
    /*height: 156px;*/
    height: 30px;
}
.comment-btn {
    width: 60px;
    height: 25px;
    border-radius: 15px;
    background: blue;
    color: #FFFFFF;
}
.input_box_btn_name{
    float:left;
    margin-top: 24px;
    cursor:pointer;
}
.input_box_btn_icon{
    float:left;
    font-size:20px;
    line-height:70px;
    margin-right:5px;
}
/deep/ .el-textarea__inner {
    border: 1px solid #606266;
}
.bottom{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    line-height:50px;
    height: 50px;
    color: #444444;
    font-size: 16px;
    text-align: center;
}

.bottom .Function{
    display: flex;
    justify-content:center;
    align-items: center;
    flex: 1;
    cursor: pointer;
}

.dynamic-operation .data_list {
    width: 50px;
    height: 32px;
    color: #fff;
    margin-top: 20px;
    padding: 10px;
    background-color: #1C7EFF;
    border-radius: 5px;
}

.dynamic-operation .data_type {
    width: 50px;
    height: 32px;
    color: #fff;
    margin-top: 20px;
    padding: 10px;
    background-color: #6d737b;
    border-radius: 5px;
}
.userName{
    color: #FFFFFF;
    font-size: 14px;
    float: left;
}
/deep/ .el-upload-dragger {
    width: 330px;
}

/deep/ .el-switch__label * {
    font-size: 16px;
}
</style>
